import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, vModelRadio as _vModelRadio, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row mt-2 px-4" }
const _hoisted_2 = { class: "col-12 offset-md-1 col-md-10 row g-0" }
const _hoisted_3 = { class: "form-group col-12 col-md-4 pe-lg-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "admission-type" }, [
  /*#__PURE__*/_createTextVNode(" Type of Admission "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Type of Admission", -1 /* HOISTED */)
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_8 = { class: "form-group col-12 col-md-4 pe-lg-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "admission-type" }, [
  /*#__PURE__*/_createTextVNode(" Admission Source "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Admission Source", -1 /* HOISTED */)
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_13 = { class: "col-12 d-flex flex-wrap mt-2" }
const _hoisted_14 = { class: "form-check custom-radio form-check-inline" }
const _hoisted_15 = ["checked"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "patientDetails-new-admission"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "New Admission")
], -1 /* HOISTED */)
const _hoisted_17 = { class: "col-12 mt-3 row g-0" }
const _hoisted_18 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "benefit-period-number" }, [
  /*#__PURE__*/_createTextVNode(" Benefit Period Number "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger ms-1" }, "*")
], -1 /* HOISTED */)
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "form-group col-12 col-lg-4 pe-lg-2" }, [
  /*#__PURE__*/_createElementVNode("label", { for: "benefit-period-number" }, " Routine Home Care Low Rate Start Date "),
  /*#__PURE__*/_createElementVNode("p", null, "Pending Admission Date")
], -1 /* HOISTED */)
const _hoisted_23 = {
  key: 0,
  class: "form-group col-12 col-lg-12 mb-0"
}
const _hoisted_24 = { for: "previous-hospice-admission" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Previous Hospice Admission Within Last 60 days ")
const _hoisted_26 = { class: "fas fa-info-circle text-primary font-size-xs" }
const _hoisted_27 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "hospiceAdmissionNo"
}, " No ", -1 /* HOISTED */)
const _hoisted_29 = { class: "custom-control custom-radio custom-control-inline mt-1" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "hospiceAdmissionYes"
}, " Yes ", -1 /* HOISTED */)
const _hoisted_31 = {
  key: 0,
  class: "form-group col-12 col-lg-4 pe-lg-4"
}
const _hoisted_32 = { for: "benefit-period-number" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Previous Enrollment Days ")
const _hoisted_34 = { class: "fas fa-info-circle text-primary font-size-xs" }
const _hoisted_35 = { class: "form-check custom-radio form-check-inline pb-3" }
const _hoisted_36 = ["checked"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", {
  class: "transfer-text",
  for: "patientDetails-hospice-to-hospice"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Hospice to Hospice Transfer")
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HospiceTransferForm = _resolveComponent("HospiceTransferForm")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_number_only = _resolveDirective("number-only")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Admission Information",
    "full-height": false,
    "validation-renderer": "bootstrap-form-renderer",
    "application-id": _ctx.application
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _withDirectives(_createElementVNode("select", {
              name: "admission-type",
              class: "form-select",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.patientDetails.admissionType) = $event)),
              onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.patientDetails.admissionType.$touch && _ctx.v$.patientDetails.admissionType.$touch(...args)))
            }, [
              _hoisted_5,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.AdmissionTypes), ([key, value]) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: value.value
                }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_6))
              }), 256 /* UNKEYED_FRAGMENT */))
            ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
              [_vModelSelect, _ctx.patientDetails.admissionType]
            ]),
            (_ctx.v$.patientDetails.admissionType.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Admission Type is required"))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("select", {
              name: "admission-type",
              class: "form-select",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.patientDetails.admissionSource) = $event)),
              onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$.patientDetails.admissionSource.$touch && _ctx.v$.patientDetails.admissionSource.$touch(...args)))
            }, [
              _hoisted_10,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.AdmissionSources), ([key, value]) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: value.value
                }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_11))
              }), 256 /* UNKEYED_FRAGMENT */))
            ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
              [_vModelSelect, _ctx.patientDetails.admissionSource]
            ]),
            (_ctx.v$.patientDetails.admissionSource.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Admission Source is required"))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("input", {
                type: "radio",
                id: "patientDetails-new-admission",
                name: "admission-source",
                class: "form-check-input au-target",
                checked: !_ctx.patientDetails.isTransfer,
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleAdmissionSourceTypeSelection())),
                disabled: false
              }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_15),
              _hoisted_16
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            (!_ctx.patientDetails.isTransfer)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control",
                      type: "text",
                      name: "benefit-period-number",
                      placeholder: "Enter Benefit Period Number",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.patientDetails.benefitPeriodNumber) = $event)),
                      disabled: _ctx.enableAdmissionBenefitPeriod,
                      onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.v$.patientDetails.benefitPeriodNumber.$touch && _ctx.v$.patientDetails.benefitPeriodNumber.$touch(...args)))
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_20), [
                      [_vModelText, _ctx.patientDetails.benefitPeriodNumber],
                      [_directive_number_only]
                    ]),
                    (_ctx.v$.patientDetails.benefitPeriodNumber.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Benefit Period is required"))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _hoisted_22,
                  (Number(_ctx.patientDetails.benefitPeriodNumber) >= 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("label", _hoisted_24, [
                          _hoisted_25,
                          _withDirectives(_createElementVNode("i", _hoisted_26, null, 512 /* NEED_PATCH */), [
                            [_directive_tooltip, {
                                            title: 'Select this option if the patient was discharged from hospice and then readmitted within 60 days of their previous discharge using the Medicare hospice benefit.'
                                        }]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            id: "hospiceAdmissionNo",
                            name: "hospiceAdmission",
                            class: "custom-control-input me-2",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.patientDetails.previousHospiceAdmission) = $event)),
                            value: false,
                            onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handlePreviousAdmissionChange(false)))
                          }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                            [_vModelRadio, _ctx.patientDetails.previousHospiceAdmission]
                          ]),
                          _hoisted_28
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            id: "hospiceAdmissionYes",
                            name: "hospiceAdmission",
                            class: "custom-control-input me-2",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.patientDetails.previousHospiceAdmission) = $event)),
                            value: true,
                            onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handlePreviousAdmissionChange(true)))
                          }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                            [_vModelRadio, _ctx.patientDetails.previousHospiceAdmission]
                          ]),
                          _hoisted_30
                        ]),
                        (
                                        Number(_ctx.patientDetails.benefitPeriodNumber) >= 2 &&
                                        _ctx.patientDetails.previousHospiceAdmission === true
                                    )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                              _createElementVNode("label", _hoisted_32, [
                                _hoisted_33,
                                _withDirectives(_createElementVNode("i", _hoisted_34, null, 512 /* NEED_PATCH */), [
                                  [_directive_tooltip, {
                                                title: 'Enter the number of days the patient received hospice services under the Medicare hospice benefit during their previous admission. This value is used to determine the transition from the routine home care high rate to the routine home care low rate.'
                                            }]
                                ])
                              ]),
                              _withDirectives(_createElementVNode("input", {
                                class: "form-control",
                                type: "text",
                                name: "previous-enrollment-days",
                                placeholder: "Previous Enrollment Days",
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.patientDetails.previousEnrollmentDays) = $event))
                              }, null, 512 /* NEED_PATCH */), [
                                [_vModelText, _ctx.patientDetails.previousEnrollmentDays]
                              ])
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("input", {
              type: "radio",
              id: "patientDetails-hospice-to-hospice",
              name: "admission-source",
              class: "form-check-input au-target",
              checked: _ctx.patientDetails.isTransfer,
              onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleAdmissionSourceTypeSelection())),
              disabled: false
            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_36),
            _hoisted_37
          ]),
          (_ctx.patientDetails.isTransfer)
            ? (_openBlock(), _createBlock(_component_HospiceTransferForm, {
                key: 0,
                benefitPeriodStartDate: _ctx.benefitPeriodStartDate,
                handleDateChange: _ctx.handleBenfitPeriodStartDate,
                benefitPeriodEndDate: _ctx.benefitPeriodEndDate,
                homePhoneNumberOptions: _ctx.homePhoneNumberOptions,
                isReadOnly: _ctx.isPendingStatus
              }, null, 8 /* PROPS */, ["benefitPeriodStartDate", "handleDateChange", "benefitPeriodEndDate", "homePhoneNumberOptions", "isReadOnly"]))
            : _createCommentVNode("v-if", true),
          (_ctx.showBenefitPeriodManager && _ctx.hasViewBenefitPeriodPermission)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "fw-bold",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$router.push('/patients/benefit-period-manager/${patient.id}')))
              }, " Benefit Period Manager "))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}